import { ColumnHeader } from '@features/campaigns';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { useState } from 'react';

export type Option = {
  name: string;
  value: string;
};

export type OptimizationSelectProps<T extends Option> = {
  selectedOptimization: T;
  setSelectedOptimization: (optimization: T['value']) => void;
  options: readonly T[];
};

/**
 * @deprecated Use OptimizationSelectV2 instead
 */
export const OptimizationSelect = <T extends Option>(
  props: OptimizationSelectProps<T>
) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  if (props.options.length === 1)
    return (
      <ColumnHeader
        color="plain"
        headerName={props.selectedOptimization.name}
      />
    );

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const {
      target: { value },
    } = event;
    props.setSelectedOptimization(value as T['value']);
    handleClose(event);
  };

  return (
    <Stack
      direction="row"
      gap="1rem"
      alignItems="center"
      onClick={handleClick}
      borderRadius="0.5rem"
      padding="0.375rem"
      sx={{ backgroundColor: unifiedPlatformColorPalette.gray100 }}
      overflow="hidden"
      title={props.selectedOptimization.name}
    >
      <Typography overflow="hidden" textOverflow="ellipsis">
        {props.selectedOptimization.name}
      </Typography>
      <FontAwesomeIcon icon={faCaretDown} />
      <Select
        value={props.selectedOptimization.value}
        onChange={handleChange}
        sx={{ display: 'none' }}
        open={open}
        onClose={handleClose}
        MenuProps={{
          anchorEl,
        }}
      >
        {props.options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
